import {Box, Flex, FormLabel, Input, Text} from '@chakra-ui/react';
import React, {useState, useRef, useEffect} from 'react';
import {CustomSelect} from '../General/FormInputs';
import {get} from '../../service/ApiService';
import {Client} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import Select from 'react-select';
import {Controller} from 'react-hook-form';

// Takes in register, errors, setValue from react-hook forms and an id for the form value when page is submitted.
export const ReactClientSelect = ({errors, id, required, disabled, defaultValue, useClientCode, control, userData, setClientId}) => {
  const [toast, setToast] = useState('');
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState(null);
  const clientInput = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {}, [defaultValue]);

  useEffect(() => {
    if (selectedClients != null) setIsLoading(false); // this is needed to ensure we have data before setting a default value
  }, [selectedClients]);

  const loadData = async id => {
    let clientList = [];
    if (userData && userData.clients) clientList.data = userData.clients;
    else clientList = await get(Client.LIST + '?PageSize=1000'); // at the time there are 200 clients, hoping this covers it so I don't have ot redo the api paging logic

    // The react-select requires a value and label
    if (clientList.data) {
      const updatedClientList = clientList.data.map(client => ({
        value: useClientCode ? client.clId : client.id,
        label: `${client.clId} | ${client.clCname}`,
        clientId: client.id,
      }));
      setClients(updatedClientList);
    }

    // This is to set the default values
    setDefaultValues();

    // Show error message if we can't get the  clients
    setToast(clientList);
  };

  const setDefaultValues = () => {
    // This is to set the default values
    let selectedList = [];
    if (defaultValue) {
      selectedList = defaultValue;
    }
    // setValues(selectedList);
    setSelectedClients(selectedList);
  };

  return (
    <Flex mr="auto" alignContent="bottom">
      <Box w="100%">
        <FormLabel fontSize="sm" mb="-0.5" ml="1">
          Select Client
        </FormLabel>
        <Controller
          control={control}
          name={id ?? clientId}
          defaultValue={defaultValue ?? null}
          rules={{required: required}}
          render={({field: {onChange, value}}) => (
            <Select
              value={clients.find(c => c.value === value)}
              onChange={val => {
                if (setClientId) setClientId(val.clientId);
                onChange(val.value);
              }}
              isDisabled={disabled ?? false}
              options={clients}
              disabled={clients.length <= 0 || isLoading || disabled}
            />
          )}
        />
        {errors[id] && (
          <Text color="red.400" fontSize="sm">
            * Client is required
          </Text>
        )}
        <ErrorHelper toastResponse={toast} />
      </Box>
    </Flex>
  );
};
